import script from "./CodeInputWithTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CodeInputWithTimer.vue?vue&type=script&setup=true&lang=ts"

import "./CodeInputWithTimer.vue?vue&type=style&index=0&id=7888bcac&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7888bcac"]])

export default __exports__